import './Timeline-e8e88a13.css';

var classes = {"Timeline":"prc-Timeline-Timeline-iQjcc","TimelineItem":"prc-Timeline-TimelineItem-Sd-t-","TimelineBadge":"prc-Timeline-TimelineBadge-BqMiN","TimelineBadgeWrapper":"prc-Timeline-TimelineBadgeWrapper-75vYD","TimelineBody":"prc-Timeline-TimelineBody-WWZY0","TimelineBreak":"prc-Timeline-TimelineBreak-dPnDJ"};

export { classes as default };
